import { ChevronLeft, User } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { MEDIA_URL } from '@/config';
import { ChatConversation } from '@/global/chat/components/Conversation';
import { Conversations } from '@/global/chat/components/Conversations';
import useConversationStore from '@/stores/Conversation';

import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';

export const MainChat = () => {
  const { isOpen, setIsOpen, selectedConversation, setSelectedConversation } =
    useConversationStore();

  return (
    <Sheet onOpenChange={setIsOpen} open={isOpen}>
      <SheetContent side="right" className="z-10000000000 p-0">
        <div className="relative flex h-full flex-col">
          {!selectedConversation ? (
            <>
              <h2 className="border-b border-border px-4 pb-5 pt-4 text-lg font-semibold">
                Conversations
              </h2>
              <Conversations />
              <footer className="border-t-stroke sticky bottom-0 left-0 right-0 border-t">
                <div className="h-24"></div>
              </footer>
            </>
          ) : (
            <>
              <h2 className="border-b border-border p-4 text-lg font-semibold">
                <div className="flex items-center gap-x-4">
                  <Button
                    variant="ghost"
                    onClick={() => setSelectedConversation(undefined)}
                    className="h-6 w-6 p-0"
                  >
                    <ChevronLeft size="16" />
                  </Button>
                  <div className="flex items-center gap-x-2">
                    <Avatar className="h-8 w-8">
                      <AvatarImage
                        src={`${
                          selectedConversation.conversationUser.profile_photo.includes(
                            'https',
                          )
                            ? selectedConversation.conversationUser
                                .profile_photo
                            : `${MEDIA_URL}/${selectedConversation.conversationUser.profile_photo}`
                        }`}
                      />
                      <AvatarFallback className="bg-secondary">
                        <User width={12} />
                      </AvatarFallback>
                    </Avatar>
                    <Link
                      to={`/profile/${selectedConversation.conversationUser.id}`}
                      onClick={() => setIsOpen(false)}
                    >
                      <div className="text-base">
                        {selectedConversation.conversationUser.username}
                      </div>
                    </Link>
                    {selectedConversation.draft && (
                      <span className="text-xs uppercase italic text-muted-foreground">
                        Draft
                      </span>
                    )}
                  </div>
                </div>
              </h2>
              <ChatConversation conversation={selectedConversation} />
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
